import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateTime from '../../DateTime';

const ActiveUsersDetails = ({ className, activeUsers, nextBillingDate }) => (
  <div className={classNames('active-users-details', className)}>
    <div className="active-users-details__title">
      {I18n.t('components.subscription.active_users_title')}
      <div className="active-users-details__title-amount">{activeUsers}</div>
    </div>
    {nextBillingDate ? (
      <div
        className="active-users-details__next-billing-date"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: I18n.t('components.subscription.next_billing_on', {
            date: DateTime({
              dateTime: nextBillingDate,
              format: 'short',
              returnStringOnly: true,
            }),
          }),
        }}
      />
    ) : null}
  </div>
);

ActiveUsersDetails.defaultProps = {
  className: '',
  nextBillingDate: null,
  activeUsers: 0,
};

ActiveUsersDetails.propTypes = {
  className: PropTypes.string,
  activeUsers: PropTypes.number,
  nextBillingDate: PropTypes.string,
};

export default ActiveUsersDetails;
